import BoardView from 'app/components/Board/BoardView'
import React from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { branch, compose, renderComponent } from 'recompose'
import { accessLevelSelector } from '../../store/selectors/accessSelectors'
import {
  cropBlockIdSelector,
  getToolsCanHide,
  rawDragOffsetSelector,
  smallScreenSelector
} from '../../store/selectors/boardSelectors'
import {
  currentBlockSelector,
  currentBoardSelector,
  modeSelector,
  shareSelector
} from '../../store/selectors/selectors'
import Loader from 'app/components/common/Loader'
import { Content } from 'common/components'

const BoardViewContainer = compose(
  firebaseConnect(({ match }) => [
    `/boards/${match.params.boardId}`,
    {
      path: `/sections/${match.params.boardId}`,
      orderByChild: 'number'
    },
    `/blocks/${match.params.boardId}`
  ]),

  connect(state => ({
    mode: modeSelector(state),
    board: currentBoardSelector(state),
    share: shareSelector(state),
    accessLevel: accessLevelSelector(state),
    toolsCanHide: getToolsCanHide(state),
    smallScreen: smallScreenSelector(state),
    currentBlock: currentBlockSelector(state),
    toolsHidden: !!rawDragOffsetSelector(state) || !!cropBlockIdSelector(state)
  })),
  branch(
    ({ board }) => !board,
    renderComponent(() => (
      <Content>
        <Loader />
        Loading board
      </Content>
    ))
  ),
  withTranslation()
)(BoardView)

export default BoardViewContainer
